import axios from "axios";
import { serialize } from "../commons/utils";
import qs from "qs";
import { Config } from "env";

export default class BaseHttpService {
    constructor() {
        this.header = {
            headers: {
                Authorization: `Bearer ${
                    JSON.parse(localStorage.getItem("auth")).accessToken
                }`,
                client_id: Config.CLIENT_ID,
            },
        };

        this.loginHeader = {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
                "Content-Type":
                    "application/x-www-form-urlencoded;charset=UTF-8",
            },
        };

        this.signupHeader = {
            headers: {
                Authorization: this.signupAuthorization,
            },
        };

        this.autoLoginHeader = {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            },
        };
    }

    setHeader = (params) => {
        this.header = {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
                ...params,
            },
        };
    };

    resetHeader = () => {
        this.header = {
            headers: {
                Authorization: `Bearer ${this.bearerToken}`,
            },
        };
    };

    // Methods Rest
    // Principals parameters:
    // url: Method URL
    // payload: parameters to send through call
    // removeBearerToken: when explicit defined, makes the call without the bearer token in the header
    get = (url, removeBearerToken) => {
        // return axios.get(url, !removeBearerToken && this.header);
        return axios.get(url, {
            headers: {
                Authorization: `Bearer ${
                    JSON.parse(localStorage.getItem("auth")).accessToken
                }`,
                client_id: Config.CLIENT_ID,
            },
        });
    };

    getSignup = (url) => {
        return axios.get(url, this.signupHeader);
    };

    getWithParams = (url, params) => {
        return axios.get(url, {
            headers: this.header,
            params: params,
            paramsSerializer: (params) => {
                return serialize(params);
            },
        });
    };

    getWithPagination = (url, params, removeBearerToken) => {
        return axios.get(url, {
            headers: !removeBearerToken ? this.header : null,
            params: params,
            paramsSerializer: (params) => {
                return serialize(params);
            },
        });
    };

    post = (url, payload) => axios.post(url, payload, this.header);

    postLogin = (url, payload) => axios.post(url, payload, this.loginHeader);

    postSignup = (url, payload) => axios.post(url, payload, this.signupHeader);

    autoLoginPost = (url, payload) =>
        axios.post(url, payload, this.autoLoginHeader);

    put = (url, payload) =>
        axios.put(url, payload, this.header);

    patch = (url, payload) =>
        axios.patch(url, payload, this.header);

    delete = (url) => axios.delete(url, this.header);

    upload = (url, formData) =>
        axios.post(url, formData, {
            headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
            },
        });

    postCredisfera = (url, payload) =>
        axios.post(url, qs.stringify({ grant_type: "client_credentials" }), {
            auth: {
                username: payload.username,
                password: payload.password,
            },
        });

    deleteAllAlerts = (url, payload) => axios.put(url, payload, {
        headers: {
            Authorization: `Bearer ${
                JSON.parse(localStorage.getItem("auth")).accessToken
            }`,
            client_id: Config.CLIENT_ID,
        },
    });

    postCredisferaWithAuth = (url, token, payload) =>
        axios.post(url, payload, {
            headers: {
                Authorization: `bearer ${token}`,
            },
        });
}
